import * as types from './index';

export const refreshTokenAction = (data) => {
    return {
    type: types.REFRESH_TOKEN,
    data
    }
};